export const SUBSCRIPTIONKEYS = {
  workshop: {
    link: 'http://workshopsoftware.com.au/watch-demo/',
    routes: {
      quote: '/company/quote_for_workshop_conversion',
      subscribe: '/company/convert_to_workshop_from_autoinspect'
    }
  }
};